import React from 'react';
import { titleCase, get } from "@dex/bubl-helpers";
import TrainingProgressApi from './TrainingProgressApi';
import ModelLink from '@dex/bubl-dash/src/lib/components/ModelLink/ModelLink';

let settings;

export default settings = {
    key: 'training/progress',
    zone: 'training',
    path: '/training/progress',
    title: "Training Progress",
    endpoint: TrainingProgressApi.endpoint,
    modelName: 'TrainingProgress',
    idKey: 'id',
    primaryKey: 'title',
    actions: ['trash', 'clone'],
    indexCaps: ["viewTrainingProgress"],
    viewCaps: ["viewTrainingProgress"],
    createCaps: ["createTrainingProgress"],
    updateCaps: ["updateTrainingProgress"],
    indexTitle: (routeName, params, users) => {

        let title: string = settings.title;

        if (params && params.name) title = title + " / " + titleCase(params.name);

        return title;

    },
    indexTabs: (routeName, params, users) => {

        return [
            {
                label: "All",
                path: settings.path,
                caps: settings.indexCaps
            },
            // {
            //     label: "Add New",
            //     path: settings.path + "/create",
            //     caps: settings.createCaps
            // },
        ]

    },
    indexButtons: (routeName, params, users) => {

        return [
            {
                label: "Add New",
                path: settings.path + '/create',
                caps: settings.createCaps
            }
        ]

    },
    indexTabCounts: (routeName, params, dontation) => {

        return settings.endpoint + "/getCounts";

    },
    indexFetch: TrainingProgressApi.get,
    indexFetchParams: (routeName, params, users) => {

        const filters: any = { where: {}, include: ['program', 'user'], order: ['created.date DESC'], limit: 10, skip: 0 };

        if (params && params.status) filters.where.status = { inq: [params.status] };

        return filters;

    },
    indexQuickSearch: (routeName, params, users) => {

        const fields = ['id'];

        return fields;

    },
    indexSearchFields: (routeName, params, users) => {

        const fields = [
            {
                label: "Title",
                key: "title",
                type: "text",
            },
            {
                label: "Program",
                key: "programId",
                type: "relationship",
                model: "TrainingPrograms",
            },
            {
                label: "User",
                key: "userId",
                type: "relationship",
                model: "User",
            }
        ];

        return fields;

    },

    indexColumns: (routeName, params, users) => {

        const columns = [
            {
                label: "",
                key: "this",
                style: { width: 120 },
                render: (value, data) => {
                    return <ModelLink modelName="TrainingProgress" data={{ id: data.id, title: "View More" }} />
                }
            },
            {
                label: "Program",
                key: "program",
                format: "ModelLink",
            },
            {
                label: "User",
                key: "user",
                format: "ModelLink",
            },
            {
                label: "Week No",
                key: "weekNo",
            },
            {
                label: "Day No",
                key: "dayNo",
            },
            {
                label: "RPE",
                key: "rpe",
            },
            {
                label: "Created",
                key: "created",
                format: "OnAndBy",
                sort: "created.date",
                alignEnd: true
            },
            {
                label: "Actions",
                key: "actions",
                alignEnd: true,
                format: "actions",
                api: TrainingProgressApi,
                settings: settings,
            }
        ];

        return columns;

    },
    singleFetch: TrainingProgressApi.getOne,
    singleFetchParams: (routeName, params, users, fetch) => {

        const filters = { include: ['program', 'user', 'session'] };

        return filters;

    },
    singleTitle: (routeName, params, users, fetch) => {

        let title: string = "Loading...";

        const complete = get(fetch, 'complete');
        const error = get(fetch, 'error');
        const data = get(fetch, 'data');

        if (error) title = "Error";
        else if (data) title = data.program.title + ' - Week ' + data.weekNo + ' - Day ' + data.dayNo;
        else if (complete && !data) title = "Not Found";

        return title;

    },
    singleTabs: (routeName, params, users, fetch) => {

        const path = settings.path + "/" + params.id;

        return [
            {
                label: "View",
                path: path + "/view"
            },
            // {
            //     label: "Edit",
            //     path: path + "/edit",
            //     caps: settings.updateCaps
            // },
        ]

    },
};